import { Menu } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  cursor: pointer;
  min-width: 100px;

  ${({ theme }) => theme.mediaQueries.PHONE} {
    width: 100%;
    border-color: #ebebeb;
  }
`;

export const LabelContainer = styled.div<{
  alignItems?: 'center' | 'flex-start' | 'flex-end';
}>`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  line-height: 1.3;
  width: 100%;
  height: 100%;
  justify-content: space-evenly;

  ${({ theme }) => theme.mediaQueries.PHONE} {
    width: 100%;
    justify-content: center;
  }

  ${({ alignItems }) =>
    alignItems &&
    `
    align-items: ${alignItems};
    padding: ${alignItems === 'center' ? '0' : '0 4px'};
  `}
`;

export const MainLabel = styled.label`
  font-size: 11px;
  white-space: nowrap;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.darkGrey};

  ${({ theme }) => theme.mediaQueries.PHONE} {
    font-weight: bold;
    width: 100%;
    margin-bottom: 0;
    font-size: 12px;
    text-align: left;
  }
`;

export const Styledlabel = styled.label`
  cursor: pointer;
  font-size: 18px;
  margin-bottom: 7.5px;

  ${({ theme }) => theme.mediaQueries.PHONE} {
    width: 100%;
    margin-bottom: 0px;
    font-size: 14px;
    text-align: left;
  }
`;

export const TimeWrapper = styled.div`
  overflow: scroll;
`;

export const MenuWrapper = styled(Menu)`
  overflow: scroll;
  height: 220px;
`;

export const DropdownButonStyled = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-left: 1px solid;
  border-right: 1px solid;
  gap: 0.6rem;
  color: black;
  height: 80px;
  border: none;

  ${({ theme }) => theme.mediaQueries.PHONE} {
    padding: 0px 10px 0px 12px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #bfbfbf;
  font-size: 14px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  div:last-child {
    border-right: none;
  }
`;
